<template>
  <v-card class="elevation-8">
    <v-toolbar dense>
      <v-toolbar-title class="subtitle-1">{{title}} Comments</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon @click="reloadMessage()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container>
    <v-card flat max-height="300px" class="overflow-hidden overflow-y-auto">
      <v-card-text v-if="messages.length > 0">
        <element v-for="(msg, index) in messages" :key="index">
          <p class="body-2 font-weight-bold">{{msg.author}}</p>
          <p class="body-1 font-weight-medium">{{msg.text}}</p>
          <p class="caption text-xs-right font-italic">{{getRelativeTime(msg.createdAt)}}</p>
          <v-divider></v-divider>
        </element>
      </v-card-text>
      <v-card-text v-else>
        <p class="body-1 fong-weight-bold">
          No Comments
        </p>
      </v-card-text>
    </v-card>
    <v-card-actions v-if="!readOnly">
      <v-textarea
        outlined
        rows="2"
        auto-grow
        v-model="messageText"
        placeholder="Write your comments here..."
      ></v-textarea>
    </v-card-actions>
    </v-container>
    <v-btn v-if="!readOnly" block dark @click="sendMessage()">Add Comment</v-btn>
  </v-card>
</template>

<script>
import store from '@/store';
import moment from 'moment';
export default {
  name: 'chatBox',
  props: {
    messages: Array,
    title: String,
    readOnly: Boolean
  },
  data() {
    return {
      messageText: ''
    };
  },
  methods: {
    sendMessage: function() {
      var message = {
        text: this.messageText,
        createdAt: new Date(),
        author: store.state.user.firstName,
        self: true
      };
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.messages.push(message);
        this.$emit('sendMessage', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function(date) {
      return moment(date).fromNow();
    }
  }
};
</script>



// WEBPACK FOOTER //
// chatbox.vue?8c16ced6